import operatingCostPositionAllocation from "./operatingCostPositionAllocation";

const operatingCostAgreement = `
    defaultDistributerType
    perDecree
    positionAllocations {
        ${operatingCostPositionAllocation}
    }
    regulationMentioned
    umlageType
`;

export default operatingCostAgreement;
